import React from "react";
import PropTypes from "prop-types";
import { Container } from "@material-ui/core";

import SectionHead from "../components/section-head";
import SEO from "../components/seo";
import Layout from "../components/layout";
import { graphql, Link } from "gatsby";
import { _ } from "../utils/i18n";

import PostFilter from "../components/post-filter";
import Header from "../components/header";
import Footer from "../components/footer";

import CardContainer from "../components/card-container";
import BlogCard from "../components/blog-card";
import EmployeeCard from "../components/employee-card";

export default function CatTemplate({ data }) {
  const block = {};
  block.attrs = {};
  block.attrs.data = {};
  block.attrs.data.type = "all";
  block.attrs.data.input = "button";
  block.attrs.data.current = data.wpCategory.name;
  block.attrs.data.posts_per_page = "-1";

  const tjenesteCount = data.allWpPost.edges.filter(
    ({ node }) => node.type === "tjeneste"
  ).length;
  const artikkelCount = data.allWpPost.edges.filter(
    ({ node }) => node.type === "post"
  ).length;
  const caseCount = data.allWpPost.edges.filter(
    ({ node }) => node.type === "case"
  ).length;
  const ansatteCount = data.allWpPost.edges.filter(
    ({ node }) => node.type === "ansatt"
  ).length;
  const sideCount = data.allWpPost.edges.filter(
    ({ node }) => node.type === "page"
  ).length;
  const results = [];
  {
    tjenesteCount > 0 &&
      results.push(
        <Link to="#tjeneste" style={{ textDecoration: "underline" }}>
          {tjenesteCount +
            " " +
            (tjenesteCount > 1 ? _("Tjenester") : _("Tjeneste"))}
        </Link>
      );
  }

  {
    artikkelCount > 0 &&
      results.push(
        <Link to="#post" style={{ textDecoration: "underline" }}>
          {artikkelCount +
            " " +
            (artikkelCount > 1 ? _("artikler") : _("artikkel"))}
        </Link>
      );
  }
  {
    caseCount > 0 &&
      results.push(
        <Link to="#case" style={{ textDecoration: "underline" }}>
          {caseCount + " " + (caseCount > 1 ? _("caser") : _("case"))}
        </Link>
      );
  }

  {
    ansatteCount > 0 &&
      results.push(
        <Link to="#ansatt" style={{ textDecoration: "underline" }}>
          {ansatteCount + " " + (ansatteCount > 1 ? _("ansatte") : _("ansatt"))}
        </Link>
      );
  }

  {
    sideCount > 0 &&
      results.push(
        <Link to="#page" style={{ textDecoration: "underline" }}>
          {sideCount + " " + (sideCount > 1 ? _("sider") : _("side"))}
        </Link>
      );
  }

  return (
    <Layout>
      <div>
        <main>
          <Header
            siteTitle="{data.site.siteMetadata.title}"
            headerColor="page"
          />
          <SEO
            title={
              data.wpCategory.seo?.title
                ? data.wpCategory.seo.title.replace("&amp;", "&")
                : data.wpCategory.name.replace("&amp;", "&")
            }
            description={
              data.wpCategory.seo?.metaDesc
                ? data.wpCategory.seo.metaDesc
                : data.wpCategory.description
            }
            url={data.wpCategory.uri}
          />

          <Container
            maxWidth="lg"
            className="disable-padding category-template"
          >
            <SectionHead
              title={
                "#" +
                data.wpCategory.name
                  .replace(/(<([^>]+)>)/gi, "")
                  .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")
                  .replace("&#038;", "&")
                  .replace("&amp;", "&")
              }
            />
            <p itemProp="articleBody" className="block-paragraph">
              {_("Vi fant")}{" "}
              {results.map((link, i) => (
                <span key={i}>
                  {results.length - 1 === i
                    ? results.length > 1
                      ? " og"
                      : ""
                    : i === 0
                    ? ""
                    : ", "}{" "}
                  {link}
                </span>
              ))}{" "}
              for &laquo;
              {data.wpCategory?.name
                .replace("&#038;", "&")
                .replace("&amp;", "&")}
              &raquo;
            </p>
            <PostFilter data={block} />
            <br />
            {tjenesteCount > 0 && (
              <div id="tjeneste">
                <h2 id="headline-1" className="block-headline">
                  {_("Tjeneste")} ({tjenesteCount})
                </h2>
                <CardContainer itemType="Blog">
                  {data.allWpPost.edges
                    .filter(({ node }) => node.type === "tjeneste")
                    .map((post, i) => (
                      <BlogCard
                        key={i}
                        imgSize="small"
                        imgUrl={post.node.featuredImage?.node?.sourceUrl}
                        link={post.node?.uri}
                        date={post.node.date}
                        category={post.node.categories?.[0]?.name}
                        linkCategory={post.node.categories?.[0]?.uri}
                        title={post.node.title}
                      />
                    ))}
                </CardContainer>
              </div>
            )}

            {artikkelCount > 0 && (
              <div id="post">
                <h2 id="headline-1" className="block-headline">
                  {_("Artikkel")} ({artikkelCount})
                </h2>
                <CardContainer itemType="Blog">
                  {data.allWpPost.edges
                    .filter(({ node }) => node.type === "post")
                    .map((post, i) => (
                      <BlogCard
                        key={i}
                        imgSize="small"
                        imgUrl={post.node.featuredImage?.node?.sourceUrl}
                        link={post.node.uri}
                        date={post.node.date}
                        category={post.node.categories?.[0]?.name}
                        linkCategory={post.node.categories?.[0]?.uri}
                        title={post.node.title}
                      />
                    ))}
                </CardContainer>
              </div>
            )}

            {caseCount > 0 && (
              <div id="case">
                <h2 id="headline-1" className="block-headline">
                  {_("Case")} ({caseCount})
                </h2>
                <CardContainer itemType="Blog">
                  {data.allWpPost.edges
                    .filter(({ node }) => node.type === "case")
                    .map((post, i) => (
                      <BlogCard
                        key={i}
                        imgSize="small"
                        imgUrl={post.node.featuredImage?.node?.sourceUrl}
                        link={post.node.uri}
                        date={post.node?.date}
                        category={post.node.categories?.[0]?.name}
                        linkCategory={post.node.categories?.[0]?.uri}
                        title={post.node?.title}
                      />
                    ))}
                </CardContainer>
              </div>
            )}

            {sideCount > 0 && (
              <div id="page">
                <h2 id="headline-1" className="block-headline">
                  {_("Side")} ({sideCount})
                </h2>
                <CardContainer itemType="Blog">
                  {data.allWpPost.edges
                    .filter(({ node }) => node.type === "page")
                    .map((post, i) => (
                      <BlogCard
                        key={i}
                        imgSize="small"
                        imgUrl={post.node.featuredImage?.node?.sourceUrl}
                        link={post.node?.uri}
                        date={post.node.date}
                        category={post.node.categories?.[0]?.name}
                        linkCategory={post.node.categories?.[0]?.uri}
                        title={post.node.title}
                      />
                    ))}
                </CardContainer>
              </div>
            )}

            {ansatteCount > 0 && (
              <div id="ansatt">
                <h2 id="headline-1" className="block-headline">
                  {_("Ansatt")} ({ansatteCount})
                </h2>
                <CardContainer itemType="Blog">
                  {data.allWpPost.edges
                    .filter(({ node }) => node.type === "ansatt")
                    .map((post, i) => (
                      <div key={i} className="donttrigger">
                        <EmployeeCard
                          img={post.node.featuredImage?.node?.sourceUrl}
                          name={post.node.title}
                          jobTitle={post.node.acf.titel}
                          tel={post.node.acf.telefon}
                          email={post.node.acf.e_post}
                        />
                      </div>
                    ))}
                </CardContainer>
              </div>
            )}
          </Container>
          <Footer />
        </main>
      </div>
    </Layout>
  );
}

CatTemplate.propTypes = {
  data: PropTypes.object,
};

export const query = graphql`
  query ($id: Int!) {
    wpCategory(databaseId: { eq: $id }) {
      name
      description
      seo {
        metaDesc
        title
      }
    }
    allWpPost(
      filter: {
        featuredImage: { node: { sourceUrl: { ne: null } } }
        categories: { nodes: { elemMatch: { databaseId: { eq: $id } } } }
        acfSearchExclude: { searchExclude: { nin: ["exclude"] } }
      }
      sort: { date: DESC }
    ) {
      edges {
        node {
          id
          title
          slug
          uri
          categories {
            nodes {
              databaseId
              name
              uri
            }
          }
          blocks {
            ...GutenbergBlocks
          }
          excerpt
          date(formatString: "MMMM DD, YYYY")
          author {
            node {
              name
            }
          }
          featuredImage {
            node {
              altText
              sourceUrl
            }
          }
        }
      }
    }
    comp: allWpPost {
      edges {
        node {
          title
          databaseId
          uri
          date

          tags {
            nodes {
              name
              databaseId
            }
          }
          categories {
            nodes {
              name
              databaseId
            }
          }
          author {
            node {
              name
            }
          }
          featuredImage {
            node {
              altText
              sourceUrl
            }
          }
        }
      }
    }
  }
`;
